import React from "react";
import { Link } from "react-router-dom";
import reportIcon from "../../assets/images/ReportPage.png";

const ReportIcon = ({ userId, pageId }) => {
  return (
    <Link to={`/web/report/?userId=${userId}&pageId=${pageId}`}>
      <img src={reportIcon} alt="reportIcon" className="report" />
    </Link>
  );
};

export default ReportIcon;
